<div 
    [class.pending]="pending"
    [class.border_def_3th]="Valid" 
    class="app_file_upload_field text-center border_r_2th">

    <div class="wrap">
        
        <label [for]="Name">
            <input 
                type="file"
                [id]="Name"
                [name]="Name"
                [accept]="Accept"
                [multiple]="Multiple"
                [disabled]="disabled"
                class="custom_input_file"
                (change)="change($event)"
            />
        </label>

        <ng-container *ngIf="Multiple == true || Valid == false || IsPreview == false">
            <img 
                alt="thumbnails"
                class="img-fluid" 
                width="50px"
                height="50px"
                [src]="ThumbnailIcons ?? '/assets/img/thumbnails.png'" 
            />
        </ng-container>
        
        <ng-container *ngIf="Multiple == false; else MultipleFiles">

            <ng-container *ngIf="currentValueHandler?.value && IsPreview">
                <img 
                    [alt]="Name"
                    class="img-fluid img_view" 
                    [src]="currentValueHandler.value | createUrl | safeUrl" 
                />
            </ng-container>
            <ng-container *ngIf="currentValueHandler?.title">
                <br>
                <div class="wrap_img_info d-inline-flex align-items-center justify-content-center position-relative">
                    <span class="label_lg_bold d-block">{{currentValueHandler.title}}</span>
                    <ng-container *ngTemplateOutlet="resetBtn" />
                </div>
            </ng-container>

        </ng-container>

        <ng-template #MultipleFiles>
            <ng-container *ngIf="currentValueHandler?.title != null">
                <br>
                <div class="wrap_img_info d-inline-flex align-items-center justify-content-center position-relative">
                    <span class="label_lg_bold d-block">{{currentValueHandler.title}}</span>
                    <ng-container *ngTemplateOutlet="resetBtn" />
                </div>
            </ng-container>
        </ng-template>

        <ng-container *ngIf="Title && Valid == false">
            <span class="label_lg_normal d-block box_title">{{Title}}</span>
        </ng-container>

        <ng-container *ngIf="ProgressTitle != null">
            <div class="wrap_file_progress_bar">
                <ng-container *ngIf="ProgressTitle?.progress;">
                    <div class="bar position-relative d-flex align-items-center justify-content-center">
                        <span class="file_progress_bar position-absolute" [style]="{width: (ProgressTitle?.progress + '%')}"></span>
                        <span class="count label_lg_bold">{{ProgressTitle?.progress + '%'}}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="ProgressTitle?.title">
                    <span class="text_done main_color label_lg_bold">{{ProgressTitle.title}}</span>
                </ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="validatorsErrorMsg">
            <ng-container *ngTemplateOutlet="ErrorTemp" />
        </ng-container>
    
        <!-- start ErrorTemp -->
        <ng-template #ErrorTemp>
            <p class="invalid color_wrong text_md_bold mb-0" *ngIf="ErrorMsg && touched" [innerHTML]="ErrorMsg || ''" ></p>        
        </ng-template> 
        <!-- start ErrorTemp -->
        
        <!-- start resetBtn -->
        <ng-template #resetBtn>
            <ng-container *ngIf="Valid">
                <div class="wrap_close text-center" (click)="reset()" >
                    <div class="close d-inline-block">
                        <span class="d-flex justify-content-center align-items-center effect">
                            <img src="/assets/img/plus.svg" alt="close">
                        </span>
                    </div>
                </div>
            </ng-container>            
        </ng-template>
        <!-- end resetBtn -->

    </div>
        
</div>